module.exports = __webpack_public_path__ + "static/media/vis_bg.4c4b3b1d.jpg";